if (!customElements.get("js-collection")) {
  customElements.define(
    "js-collection",
    class jsCollection extends HTMLElement {
      constructor() {
        super();
        this.page = 1;
        this.filterValues = [];
        this.sortValue = "#sort_all";
        this.handle = this.querySelector(".js-collection-grid").dataset.collection;
        // this.prePageShow = this.querySelector(".js-collection__pagination").dataset.show;
        this.products = [];
        this.filteredProducts = [];
        this.elements = {
          header: this.querySelector(".js-collection__header"),
          filterButton: this.querySelector(".js-collection__filter-button"),
          filterIcon: this.querySelector(".icon-filter"),
          closeIcon: this.querySelector(".icon-close"),
          sortButton: this.querySelector(".js-collection__sort-label"),
          sortItem: this.querySelectorAll(".js-collection__sort-item"),
          sortList: this.querySelector(".js-collection__sort-list"),
          headerBottom: this.querySelector(".js-collection__header-bottom"),
          filterItems: this.querySelectorAll(".js-collection__filter-input"),
          collectionGrid: this.querySelector(".js-collection-grid"),
          filterInners: this.querySelectorAll(".js-collection__filter-inner"),
          // paginationPrev: this.querySelector(".js-collection__pagination-prev"),
          // paginationNext: this.querySelector(".js-collection__pagination-next"),
          // paginationList: this.querySelector(".js-collection__pagination-items"),
        };
        this.elements.filterButton.addEventListener("click", this.openFilterPanel.bind(this));
        this.elements.sortButton.addEventListener("click", this.openSortList.bind(this));
        // this.elements.filterItems.forEach((item) => item.addEventListener("change", this.changeFilteralues.bind(this)));
        this.elements.sortItem.forEach((item) => item.addEventListener("click", this.changeSortValue.bind(this)));
        // this.elements.paginationNext.addEventListener("click", this.nextPage.bind(this));
        // this.elements.paginationPrev.addEventListener("click", this.prevPage.bind(this));
        this.getCollection();
        this.initSort();
      }

      initSort() {
        const urlParams = new URLSearchParams(window.location.search);
        const sortBy = urlParams.get("sort_by");
        let sortLabel = "Featured";

        if (sortBy === "best-selling") {
          sortLabel = "Best Selling";
        } else if (sortBy === "title-ascending") {
          sortLabel = "Alphabetically, A-Z";
        } else if (sortBy === "title-descending") {
          sortLabel = "Alphabetically, Z-A";
        } else if (sortBy === "price-ascending") {
          sortLabel = "Price, low to high";
        } else if (sortBy === "price-descending") {
          sortLabel = "Price, high to low";
        } else if (sortBy === "created-ascending") {
          sortLabel = "Date, old to new";
        } else if (sortBy === "created-descending") {
          sortLabel = "Date, new to old";
        }

        document.querySelector(".selected-sort-option").innerHTML = sortLabel;
      }

      openFilterPanel(event) {
        event.preventDefault();
        this.elements.headerBottom.classList.toggle("hidden");
        event.currentTarget.classList.toggle("active");
        this.elements.filterIcon.classList.toggle("hidden");
        this.elements.closeIcon.classList.toggle("hidden");
      }

      openSortList(event) {
        event.preventDefault();
        this.elements.sortList.classList.toggle("hidden");
        event.currentTarget.classList.toggle("active");
      }

      changeFilteralues(event) {
        event.preventDefault();
        this.filterValues = [];
        this.elements.filterInners.forEach((item) => {
          const key = item.querySelector(".js-collection__filter-title").textContent.trim();
          var values = [];
          item.querySelectorAll(".js-collection__filter-input").forEach((input) => {
            if (input.checked) {
              values.push(input.value);
            }
          });
          var arr = [key, values];
          this.filterValues.push(arr);
        });
        this.filterProducts();
      }

      changeSortValue(event) {
        event.preventDefault();
        this.sortValue = event.target.dataset.value;
        this.elements.sortButton.querySelector("b").textContent = event.currentTarget.textContent.trim();
        this.elements.sortList.classList.toggle("hidden");
        this.elements.sortButton.classList.toggle("active");
        let url = new URL(document.location.href);
        url.searchParams.delete("sort_by");
        url.searchParams.append("sort_by", event.target.dataset.value);
        document.location.href = url.href;
      }

      sortProducts() {
        const sort_arr = this.products.filter((item) => item.tags.indexOf(this.sortValue) > -1);
        const new_arr = sort_arr.concat(this.products);

        const uniq_arr = [...new Set(new_arr)];
        this.products = uniq_arr;
      }

      prevPage(event) {
        event.preventDefault();
        this.page -= 1;
        this.renderProducts();
      }

      nextPage(event) {
        event.preventDefault();
        this.page += 1;
        this.renderProducts();
      }

      changePage(event) {
        event.preventDefault();
        this.page = Number(event.currentTarget.textContent.trim());
        this.renderProducts();
      }

      renderPagination() {
        const pageCount = this.filteredProducts.length / this.prePageShow + 1;
        this.elements.paginationList.innerHTML = "";
        for (var i = 1; i <= pageCount; i++) {
          var pageClass = "js-collection__pagination-item";
          if (i == this.page) pageClass += " active";
          const page = document.createElement("a");
          page.setAttribute("href", "#");
          page.textContent = i;
          page.classList.add("js-collection__pagination-item");
          if (i == 1) {
            if (this.page == 1) this.elements.paginationPrev.classList.add("disabled");
            else this.elements.paginationPrev.classList.remove("disabled");
          }
          if (i == pageCount.toFixed(0)) {
            if (this.page == pageCount.toFixed(0)) this.elements.paginationNext.classList.add("disabled");
            else this.elements.paginationNext.classList.remove("disabled");
          }
          if (i == this.page) page.classList.add("active");
          this.elements.paginationList.appendChild(page);
          page.addEventListener("click", this.changePage.bind(this));
        }
      }

      filterProducts() {
        var products = this.products;
        if (document.querySelectorAll(".js-collection__filter-input:checked").length == 0) {
          this.filteredProducts = this.products;
        } else {
          this.filteredProducts = products.filter((product) => {
            var f = false;
            this.filterValues.forEach((filter) => {
              if (filter[1].indexOf(product[filter[0]]) > -1) f = true;
              return false;
            });
            return f;
          });
        }

        let filterCounts = document.querySelectorAll(".filter-count");
        let numberProducts = this.filteredProducts.length; // Make sure this is the correct reference

        filterCounts.forEach(function (filterCountElement) {
          filterCountElement.innerHTML = `CLEAR FILTERS (${numberProducts})`;
        });
        this.renderProducts();
      }

      getCollection() {
        let _this = this;
        fetch(`/collections/${this.handle}/products.json?limit=250`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok.");
            }
            return response.json();
          })
          .then(async (data) => {
            const sort_arr = data.products.filter((item) => item.tags.indexOf("sort_all") > -1);
            const new_arr = sort_arr.concat(data.products);
            const uniq_arr = [...new Set(new_arr)];
            let products = [];

            for (let index = 0; index < uniq_arr.length; index++) {
              const element = uniq_arr[index];
              const response = await fetch(`/products/${element.handle}?view=metafields`, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              });
              const result = await response.text();
              products.push(JSON.parse(result));
            }
            _this.filteredProducts = products;
            // _this.renderProducts();

            // uniq_arr.forEach(async (product, index) => {
            //   const response = await fetch(`/products/${product.handle}?view=metafields`, {
            //     method: "GET",
            //     headers: {
            //       "Content-Type": "application/json",
            //     },
            //   })
            //   const result = await response.text();
            //   var doc = new DOMParser().parseFromString(result, "text/html");
            //   const p = JSON.parse(doc.querySelector("body").textContent.trim());

            //   _this.products.push(p);
            //   if (index == uniq_arr.length - 1) {
            //     _this.filteredProducts = _this.products;
            //     _this.renderProducts();
            //   }
            // });
          })
          .catch((error) => {
            console.error("There has been a problem with your fetch operation:", error);
          });
      }

      renderProducts() {
        // this.renderPagination();
        const start = (this.page - 1) * this.prePageShow;
        const end = this.page * this.prePageShow;
        var html = "";
        this.filteredProducts.forEach((product, index) => {
          if (index >= start && index < end) {
            if (index == 2) {
              let pageLink = document.getElementById("whyMtm_link");
              html += pageLink.innerHTML;
            } else {
              html += `

                                <div class="js-collection__product-item ">
                                 <a href="${product.url}">
                                    <div class="js-collection__product-image h-0 custom-sm:pb-[136%] pb-[136%] rounded-sm relative">
                                        <img src="${product.image}" alt="${product.title}" class="absolute w-full h-full left-0 top-0 object-cover object-center">
                                    </div>
                                    <div class="js-collection__product-info flex max-md:flex-col items-start justify-start md:self-start md:justify-between pt-5 font-semibold tracking-normal">
                                        <span class="js-collection__product-title text-base leading-6 tracking-wide text-left h4 font-PublicSans pb-1 font-semibold">${product.title}</span>
                                        <span class="js-collection__product-price text-sm text-[#3C3C3C] font-semibold">${product.price}</span>
                                    </div>
                                    </a>
                                </div>

                    `;
            }
          }
        });
        this.elements.collectionGrid.innerHTML = html;
      }
    }
  );
}
